import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { DeviceService } from 'app/services/device.service';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { MatIconModule } from '@angular/material/icon';

@Component({
  standalone: true,
  imports: [CommonModule, MatIconModule],
  selector: 'app-rotate-prompt',
  templateUrl: './rotate-phone.component.html',
  styleUrls: ['./rotate-phone.component.scss'],
})
export class RotatePromptComponent implements OnInit {
  showRotatePrompt = false;
  private isMobileDevice = false;
  private currentUrl = '';
  private destroy$ = new Subject<void>();

  constructor(
    private deviceService: DeviceService,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    // Subscribe to router events to get the current URL

    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe((event: NavigationEnd) => {
        this.currentUrl = event.urlAfterRedirects;
        this.updateRotationState();
      });

    // Determine if the device is a mobile phone
    this.deviceService.isMobile$
      .pipe(takeUntil(this.destroy$))
      .subscribe(isMobile => {
        this.isMobileDevice = isMobile;
        this.updateRotationState();
      });



    // Listen for orientation changes
    window.matchMedia('(orientation: landscape)').addEventListener('change', (e) => {
      this.updateRotationState();

    });



 
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    // It's good practice to also remove the event listener
    window.matchMedia('(orientation: landscape)').removeEventListener('change', this.updateRotationState);
  }

  @HostListener('window:resize')
  onResize() {
    this.updateRotationState();

  }

  /**
   * Checks conditions and sets the visibility of the rotation prompt.
   * The prompt is shown only on mobile devices that are in landscape mode
   * and on specific pages.
   */
  private updateRotationState() {
    const isLandscape = window.matchMedia('(orientation: landscape)').matches;
    const urlHasMember = this.currentUrl?.includes('member');

    // Condition: Show ONLY on mobile devices in landscape AND on a '/member' URL
    // this.showRotatePrompt = this.isMobileDevice && isLandscape && urlHasMember;
    // console.log("showrorate", this.showRotatePrompt);

    // Trigger change detection to ensure the view updates
    this.cdr.detectChanges();
 


  }
}